import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sidebar-menu d-lg-block d-none list-reset mt-4" }
const _hoisted_2 = { class: "py-5 sidebar-menu__mobile" }

import { ref, onMounted } from 'vue';
import SidebarMenuItem from './SidebarMenuItem.vue';
import AccordionSelect from './AccordionSelect.vue';



export default {
  __name: 'SidebarMenu',
  props: {
  target: {
    type: String,
    required: true,
  },
},
  setup(__props) {



const list = ref([]);

onMounted(() => {
  const menus = document.querySelectorAll('.accordions-list');
  menus.forEach((menu) => {
    const label = menu.querySelector('h3')?.textContent;
    if (menu.id && label) {
      list.value.push({
        id: menu.id,
        label: label,
      });
    }
  });
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
        return (_openBlock(), _createBlock(SidebarMenuItem, {
          item: item,
          isYellow: true,
          key: item.id
        }, null, 8 /* PROPS */, ["item"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_2, [
      (list.value && list.value.length > 0)
        ? (_openBlock(), _createBlock(AccordionSelect, {
            key: 0,
            list: list.value
          }, null, 8 /* PROPS */, ["list"]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

}